import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Note ")
const _hoisted_3 = {
  key: 0,
  class: "p-fluid p-mt-3"
}
const _hoisted_4 = {
  key: 1,
  class: "p-fluid p-mt-3"
}
const _hoisted_5 = {
  key: 2,
  class: "p-fluid p-mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-my-2" }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      (_ctx.isTMT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_FloatLabel, { label: "Note interne" }, {
              default: _withCtx(() => [
                _createVNode(_component_Textarea, {
                  autoResize: true,
                  modelValue: _ctx.order.note_tmt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.order.note_tmt = $event)),
                  disabled: !_ctx.isTMT
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTMT || _ctx.isCustomer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_FloatLabel, {
              label: _ctx.isCustomer ? 'Note' : 'Note per il cliente'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Textarea, {
                  autoResize: true,
                  modelValue: _ctx.order.note_customer,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.order.note_customer = $event)),
                  disabled: !_ctx.isTMT && !_ctx.isCustomer
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTMT || _ctx.isSupplier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_FloatLabel, {
              label: _ctx.isSupplier ? 'Note' : 'Note per il fornitore/taker'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Textarea, {
                  autoResize: true,
                  modelValue: _ctx.order.note_supplier,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.order.note_supplier = $event)),
                  disabled: !_ctx.isTMT
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}